import { Input, OnInit, OnDestroy } from '@angular/core';
import { ParameterLoaderService } from '../parameter-loader.service';
import { combineLatest, Subject } from 'rxjs';
import { withLatestFrom, takeUntil } from 'rxjs/operators';

export class BaseParameterComponent implements OnInit, OnDestroy {
  @Input() parameterData: any;
  @Input() updateFn: (value: string | number) => void;

  public title: string;
  public icon: string;
  public hide: boolean;

  private readonly UNDER = "Opening aansluiting rolstoel φ [mm]";
  private readonly ABOVE = "Bevestiging bovenzijde φ [mm]";
  private readonly BALLDEPTH = "Baldiepte";
  private readonly BALLMIDDLE = "Bal in het midden";
  private readonly TABLETHICKNESS = "Tafeldikte [mm]";

  private under$ = this.parameterLoader.parameters[this.UNDER];
  private above$ = this.parameterLoader.parameters[this.ABOVE];
  private balldepth$ = this.parameterLoader.parameters[this.BALLDEPTH];
  private ballmiddle$ = this.parameterLoader.parameters[this.BALLMIDDLE];
  private tablethickness$ = this.parameterLoader.parameters[this.TABLETHICKNESS];

  unsubscribe$ = new Subject<void>();

  constructor(private parameterLoader: ParameterLoaderService) { }

  ngOnInit(): void {
    this.title = this.parameterData.name;
    console.log('this.parameterData = ', this.parameterData);
    const metaData = JSON.parse(this.parameterData.data === "" ? "{}" : this.parameterData.data);
    console.log('metaData = ', metaData);
    this.icon = metaData.icon;

    if (metaData.hideIf) {
      const hideIfParameterName: string = Object.keys(metaData.hideIf)[0];
      const hideIfParameterValue = Object.values(metaData.hideIf)[0].toString();
      this.parameterLoader.parameters[hideIfParameterName].subscribe((value) => {
        this.hide = value === hideIfParameterValue;
      });
    }

    this.parameterLoader.parameters[this.parameterData.name].subscribe(
      (value) => {
        console.log("Update value", this.parameterData.name, value);
        if (value != this.parameterData.value) {
          this.parameterData.value = value;
          this.updateFn(value);
        }
      }
    );

    if (this.parameterData.name === this.ABOVE) {
      this.under$.pipe(
        withLatestFrom(this.above$),
        takeUntil(this.unsubscribe$)
      ).subscribe(([under, above]) => {
        if (above > under - 1) {
          this.parameterData.value = under - 1;
          this.updateFn(under - 1);
        }
      });
    }

    if (this.parameterData.name === this.UNDER) {
      this.above$.pipe(
        withLatestFrom(this.under$),
        takeUntil(this.unsubscribe$)
      ).subscribe(([above, under]) => {
        if (under < above + 1) {
          this.parameterData.value = above + 1;
          this.updateFn(above + 1);
        }
      });
    }

    if (this.parameterData.name === this.BALLMIDDLE) {
      this.ballmiddle$.pipe(
        withLatestFrom(this.balldepth$, this.tablethickness$),
        takeUntil(this.unsubscribe$)
      ).subscribe(([ballmiddle, balldepth, tablethickness]) => {
        if (ballmiddle === "Ja" && tablethickness < balldepth + 2) {
          this.balldepth$.next(tablethickness - 2);
        }
      })
    }

    if (this.parameterData.name === this.BALLDEPTH) {
      this.tablethickness$.pipe(
        withLatestFrom(this.balldepth$, this.ballmiddle$),
        takeUntil(this.unsubscribe$)
      ).subscribe(([tablethickness, balldepth, ballmiddle]) => {
        if (ballmiddle === "Ja" && tablethickness < balldepth + 2) {
          this.balldepth$.next(tablethickness - 2);
        }
      })
    }

    if (this.parameterData.name === this.TABLETHICKNESS) {
      this.balldepth$.pipe(
        withLatestFrom(this.tablethickness$, this.ballmiddle$),
        takeUntil(this.unsubscribe$)
      ).subscribe(([balldepth, tablethickness, ballmiddle]) => {
        if (ballmiddle === "Ja" && tablethickness < balldepth + 2) {
          this.tablethickness$.next(balldepth + 2);
        }
      })
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
